import { Container } from "@mui/material";
import React from "react";

type ContentProps = {
  children: React.ReactNode;
};
const ContainerCustom = (props: ContentProps) => {
  const { children } = props;
  return (
    <Container maxWidth="xl" sx={{margin:'0 auto !important'}} disableGutters className="flex flex-1 justify-center p-2 w-full">
      {children}
    </Container>
  );
};

export default ContainerCustom;
